import { IconUserPlus } from '@tabler/icons-react'
import { Button } from '@/components/ui/button'
import { useUsers } from '../context/users-context'
import { useTranslation } from 'react-i18next'
import { PermissionGuard } from '@/components/permission-guard'
import { UserPermission } from '@/constants/permissions'

export function UsersPrimaryButtons() {
    const { setOpen } = useUsers()
    const i18n = useTranslation()
    return (
        <div className='flex gap-2'>
            <PermissionGuard permission={UserPermission.ADD_USER}>
                <Button className='space-x-1' onClick={() => setOpen('add')}>
                    <span>{i18n.t('add_user')}</span> <IconUserPlus size={18} />
                </Button>
            </PermissionGuard>
        </div>
    )
}
